import {bankingRequest, request} from '../services/request';
import {backendEndpoints, bankingEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';
import {vendorsConstants} from "../constants";

const errorHandlerProps = {disableAlert: true};

const {getUrl} = apiHelpers;

const createVendor = ({data, headers, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      data,
      headers,
      url: backendEndpoints.POST_VENDOR_CREATE,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const deleteVendor = ({id, headers, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      headers,
      url: getUrl(backendEndpoints.DELETE_VENDOR, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getVendor = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_VENDOR, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getVendors = ({query = null, successCallback, errorCallback, storeInRedux = false} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_VENDORS,
      query,
      successCallback: (response) => {
        if (storeInRedux) {
          dispatch({type: vendorsConstants.GET_VENDORS, data: response.results});
        }
        successCallback?.(response);
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateStoredVendorInList = (vendor) => {
  return (dispatch, getState) => {
    let vendors = getState().vendor.vendors;
    vendors = vendors.map(v => v.vendor_id === vendor.vendor_id ? vendor : v);
    dispatch({type: vendorsConstants.GET_VENDORS, data: vendors});
  }
}

const updateVendor = ({id, data, headers, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      data,
      headers,
      url: getUrl(backendEndpoints.PUT_VENDOR_UPDATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBeneficiary = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    bankingRequest.get({
      dispatch,
      url: getUrl(bankingEndpoints.GET_BENEFICIARY, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateBeneficiary = ({id, data, headers, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    bankingRequest.put({
      dispatch,
      data,
      headers,
      url: getUrl(bankingEndpoints.PUT_BENEFICIARY_UPDATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createPayment = ({data, headers, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      data,
      headers,
      url: backendEndpoints.POST_PAYOUT_CREATE,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getVendorPayments = ({id, query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      query,
      url: getUrl(backendEndpoints.GET_VENDOR_PAYOUTS, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBatchVendors = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      data,
      url: backendEndpoints.POST_VENDORS_ACCOUNTING_BATCH,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}


export const vendorsActions = {
  createVendor,
  deleteVendor,
  getBeneficiary,
  getVendor,
  getVendors,
  getBatchVendors,
  updateBeneficiary,
  updateVendor,
  updateStoredVendorInList,

  createPayment,
  getVendorPayments,
};
